<main class="app-layout d-flex vh-100 overflow-hidden">
  <aside
    class="app-layout__sidebar d-none d-md-block"
    [class.app-layout__sidebar--collapsed]="sidebarCollapsed">
    <app-side-bar
      [menuData]="menu"
      [collapsed]="sidebarCollapsed"
      (collapsedChange)="sidebarCollapsed = $event">
    </app-side-bar>
  </aside>

  <div class="app-layout__content flex-grow-1 d-flex flex-column overflow-hidden">
    <app-header-dashboard/>

    <div class="app-layout__page flex-grow-1 overflow-auto bg-secondary">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>

@if (slideMenuService.showed) {
  <app-side-menu
    [menuData]="menu">
  </app-side-menu>
}
